import { useState, useEffect, useCallback } from "react";

export function usePopoverPosition(triggerRef: React.RefObject<HTMLElement | null>) {
  const [side, setSide] = useState<"top" | "bottom">("bottom");

  const calculatePosition = useCallback(() => {
    if (!triggerRef.current) return;

    const rect = triggerRef.current.getBoundingClientRect();
    const spaceAbove = rect.top;
    const spaceBelow = window.innerHeight - rect.bottom;

    // Prefer bottom unless there's significantly more space above
    setSide(spaceAbove > spaceBelow ? "top" : "bottom");
  }, [triggerRef]);

  useEffect(() => {
    // Initial calculation
    calculatePosition();

    // Recalculate on resize or scroll
    window.addEventListener("resize", calculatePosition);
    window.addEventListener("scroll", calculatePosition);

    return () => {
      window.removeEventListener("resize", calculatePosition);
      window.removeEventListener("scroll", calculatePosition);
    };
  }, [calculatePosition]);

  return side;
}